import {
  Mtds,
  SampleFormData,
  getSampleRegistrationSchema,
  getSampleRegistrationUiSchema,
  CheckIcon,
  useSampleForm,
  ThemedForm,
  ExternalReferenceType,
  Geometry
} from 'prove-common'
import { IChangeEvent, RJSFSchema } from 'prove-common/rjsf'

type SampleRegistrationFormProps = {
  schema: RJSFSchema | undefined
  isSaving: boolean
  isEditing: boolean
  externalReferenceType: ExternalReferenceType | undefined
  existingFormData?: Partial<SampleFormData>
  onSubmit: (data: IChangeEvent<SampleFormData>) => void
  onCancel: () => void
  isPartiallyEditable?: boolean
  position?:
    GeolocationPosition | { longitude: number; latitude: number } | Geometry
}

export default function SampleRegistrationForm({
  schema,
  isSaving,
  isEditing,
  externalReferenceType,
  existingFormData,
  onSubmit,
  onCancel,
  isPartiallyEditable = false,
  position
}: Readonly<SampleRegistrationFormProps>) {
  const useLokalitetWidget = externalReferenceType === 'LOKALITET'
  const {
    formData,
    validator,
    customValidate,
    transformErrors,
    formContext,
    isFetching,
    onChange
  } = useSampleForm({ schema, existingFormData, isPartiallyEditable, position })
  return (
    <ThemedForm
      noHtml5Validate
      schema={getSampleRegistrationSchema(
        schema,
        isEditing,
        useLokalitetWidget,
        isPartiallyEditable
      )}
      uiSchema={getSampleRegistrationUiSchema(
        schema,
        isEditing,
        useLokalitetWidget,
        isPartiallyEditable
      )}
      formContext={formContext}
      formData={formData}
      showErrorList='bottom'
      validator={validator}
      customValidate={customValidate}
      transformErrors={transformErrors}
      disabled={isFetching}
      onSubmit={onSubmit}
      onChange={onChange}
      omitExtraData
      experimental_defaultFormStateBehavior={{ constAsDefaults: 'skipOneOf' }}
    >
      <Mtds.Flex className='mt-8'>
        <Mtds.Button data-variant='secondary' onClick={onCancel}>
          Avbryt
        </Mtds.Button>
        <Mtds.Button
          aria-busy={isSaving}
          disabled={isSaving || isFetching}
          data-variant='primary'
          type='submit'
        >
          <CheckIcon />
          Lagre prøve
        </Mtds.Button>
      </Mtds.Flex>
    </ThemedForm>
  )
}
